<template>
  <div class="animated fadeIn">
    <b-alert :variant="dismissibleType"
             dismissible
             :show="showDismissibleAlert"
             @dismissed="showDismissibleAlert=false">
      {{ errMsg }}
    </b-alert>

    <div>
      <b-card>
        <!-- User Interface controls -->
        <b-row>
          <b-col v-if="CanCreateNewUser" md="4" class="my-0">
            <button id="btnAddNewUser" class="btn btn-success" @click="addUser()">
              <i class="fa fa-plus-square" title="Add a new user"></i> <strong class="text-white">Add a new user</strong>
            </button>
          </b-col>

          <b-col md="4" class="my-0">
            <b-form-group class="my-1">
              <b-input-group v-on:keyup.enter="submitSearch">
                <b-form-checkbox id="chkActiveUsers" class="mx-3" v-model="filterShowActiveUsersOnly" @change="submitSearch">Show active users only</b-form-checkbox>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>
        <br />
        <!-- Main table element -->
        <b-table :items="FilteredRecords" :fields="myfields" hover striped bordered small :current-page="currentPage" :sort-compare="onNewSort" :per-page="perPage" show-empty>
          <template id="iLastLogin" v-slot:cell(LAST_LOGIN_TS)="data">
            <!--<span v-text="test(data)"></span>-->
            {{ data.item.LAST_LOGIN_TS | formatDate }}
          </template>

          <template v-slot:cell(LAST_LOGOUT_TS)="data">
            {{  data.item.LAST_LOGOUT_TS | formatDate }}
          </template>

          <template v-slot:cell(ACCESS_DEALER_PORTAL)="data">
            <div v-if="!IsAdmin(data.item.USER_ID)">
              <b-row style="padding-top:5px;">
                <b-col md="12">
                  <c-switch id="iHasDealPortAccMain" @change="dealerPortalAccessChanged(data.item)" v-model="data.item.ACCESS_DEALER_PORTAL" type="text" variant="primary" on="Yes" off="No" :pill="true" />
                </b-col>
              </b-row>
            </div>
            <div v-if="IsAdmin(data.item.USER_ID)">
              {{ data.item.ACCESS_DEALER_PORTAL | formatAccessDisplay }}
            </div>
          </template>

          <template v-slot:cell(KIOSK_MODE)="data">
            <div>
              <b-row style="padding-top:5px;">
                <b-col md="12">
                  <c-switch id="iKioskMain" @change="kioskModeChanged(data.item)" v-model="data.item.KIOSK_MODE" type="text" variant="primary" on="Yes" off="No" :pill="true" />
                </b-col>
              </b-row>
            </div>
          </template>

          <template v-slot:cell(DISABLED)="data">
            <b-row style="padding-top:5px;">
              <b-col md="12" v-if="IsDisabled(data.item)">
                <span class="badge badge-info text-white">DISABLED</span>
              </b-col>
            </b-row>
          </template>

          <template v-slot:cell(Actions)="data">
            <b-row style="padding-top:5px; min-width:135px;">
              <b-col md="12" class="p-0">
                <button class="btn btn-primary btn-sm text-white" @click="openUserDetail(data.item.USER_ID)">
                  <i class="fa fa-edit" title="Edit"></i> <strong class="text-white">Edit</strong>
                </button>

                <button v-if="!IsDisabled(data.item) && !IsAdmin(data.item.USER_ID)" class="btn btn-warning btn-sm text-white" @click="confirmDisable(data.item.USER_ID)">
                  <i class="fa fa-toggle-off" title="Disable"></i> <strong class="text-white">Disable</strong>
                </button>

                <button v-if="IsDisabled(data.item) && CanCreateNewUser" class="btn btn-success btn-sm text-white" @click="confirmEnable(data.item.USER_ID)">
                  <i class="fa fa-toggle-on" title="Enable"></i> <strong class="text-white">Enable&nbsp;</strong>
                </button>
              </b-col>
            </b-row>
          </template>

        </b-table>
        <nav>
          <b-pagination :total-rows="getRowCount()" :per-page="perPage" v-model="currentPage" prev-text="Prev" next-text="Next" />
        </nav>
      </b-card>
    </div>
    <b-modal ref="addEditUserModal" hide-footer title="Add/Edit User" show="modalOpen">
      <userManagementDetail :selUserId="selUserId" @clicked="ToggleModal"></userManagementDetail>
    </b-modal>
    <loading :show="boolLoading"
             :label="txtLoading">
    </loading>
  </div>
</template>

<script>
import axios from 'axios'
import loading from 'vue-full-loading'
import moment from 'moment'
import cSwitch from '../components/Switch'
import userManagementDetail from '@/views/UserManagementDetail'

export default {
  components: {
    loading,
    cSwitch,
    userManagementDetail
  },
  created () {
    this.fetchData()
  },
  filters: {
    formatDate: function (date) {
      var m = moment(date)
      if (m.isValid()) {
        return m.add(moment().utcOffset(), 'm').format('MM/DD/YYYY hh:mm:ss a')
      }
      return ''
    },
    formatAccessDisplay: function (accessBool) {
      var display = 'No'
      if (accessBool) {
        display = 'Yes'
      }
      return display
    }
  },
  data () {
    return {
      errMsg: '',
      dismissibleType: 'danger',
      showDismissibleAlert: false,
      boolLoading: false,
      txtLoading: 'Loading...',
      activePartner: null,
      maximum_users: undefined,
      lastRefreshed: moment(),
      users: [],
      modalOpen: false,
      filterShowActiveUsersOnly: true,
      totalCount: 0,
      tbxFilter: '',
      myfields: [
        { key: 'NAME', label: 'Username', sortable: true },
        { key: 'FIRST_NAME', label: 'First Name', sortable: true },
        { key: 'LAST_NAME', label: 'Last Name', sortable: true },
        { key: 'EMAIL', label: 'Email', sortable: true },
        { key: 'LAST_LOGIN_TS', label: 'Last Login', sortable: true },
        { key: 'LAST_LOGOUT_TS', label: 'Last Logout', sortable: true },
        { key: 'ACCESS_DEALER_PORTAL', label: 'Has mPortal access', sortable: true },
        { key: 'KIOSK_MODE', label: 'Kiosk Mode', sortable: true },
        { key: 'MANAGER_EMAIL', label: 'Manager Email', sortable: true },
        { key: 'DISABLED', label: 'Disabled', sortable: true },
        { key: 'Actions', label: '', sortable: false }
      ],
      currentPage: 1,
      selUserId: -1,
      perPage: 10,
      totalRows: 0,
      onNewSort (a, b, key) {
        if (['LAST_LOGIN_TS', 'LAST_LOGOUT_TS'].indexOf(key) !== -1) {
          switch (key) {
            // case 'FUTUREUNKNOW':
            //  console.log(`${JSON.stringify(new Date())} (typeof a) ${(typeof a[key])} [${JSON.stringify(a[key])}] (typeof a) ${(typeof a[key])} [${JSON.stringify(a[key])}]`);
            //  break;
            case 'LAST_LOGOUT_TS':
            case 'LAST_LOGIN_TS':
              var a1 = moment(a[key])
              var b1 = moment(b[key])

              if (a1.isValid() && b1.isValid()) {
                if (a1.isSame(b1)) {
                  return 0
                }
                if (a1.isAfter(b1)) {
                  return 1
                }
                return -1
              } else {
                if (a1.isValid()) {
                  return 1
                }
                if (b1.isValid()) {
                  return -1
                }
              }
              return 0
          }
        } else {
          if (typeof a[key] === 'number' && typeof b[key] === 'number') {
            // If both compared fields are native numbers
            return a[key] < b[key] ? -1 : (a[key] > b[key] ? 1 : 0)
          } else if (typeof a[key] === 'boolean' && typeof b[key] === 'boolean') {
            let a1 = ((a[key] + '').toLowerCase().trim() === 'true') ? 1 : 0
            let b1 = ((b[key] + '').toLowerCase().trim() === 'true') ? 1 : 0
            return a1 < b1 ? 1 : (a1 > b1 ? -1 : 0)
          } else {
            let a1 = (a[key] + '')
            let b1 = (b[key] + '')
            return (a1).localeCompare(b1)
          }
        }
      }
    }
  },
  methods: {
    test (i) {
      console.log(JSON.stringify(new Date()) + ':(i) > ' + JSON.stringify(i))
    },
    submitSearch () {

    },
    getRowCount () {
      return this.FilteredRecords.length
    },

    fetchData () {
      axios.get('/api/UserManagement/GetAll')
        .then(response => {
          this.boolLoading = false

          this.users = response.data.USERS
          this.totalCount = this.users.length
          this.lastRefreshed = moment()

          this.maximum_users = parseInt(response.data.MAXIMUM_USERS)
        })
        .catch(error => {
          if (error.response.status === 403) { this.$router.push('/login') }

          this.boolLoading = false
          this.errMsg = 'There was an error getting data : ' + error
          this.showDismissibleAlert = true
        })
    },
    dealerPortalAccessChanged (user) {
      var self = this
      this.boolLoading = true
      var obj = {
        USER_ID: user.USER_ID,
        ACCESS_DEALER_PORTAL: user.ACCESS_DEALER_PORTAL
      }
      axios.post('/api/UserManagement/ChangeDealerPortalAccess', obj)
        .then(response => {
          self.boolLoading = false
        })
        .catch(error => {
          if (error.response.status === 403) { this.$router.push('/login') }

          this.boolLoading = false
          this.errMsg = 'There was an error deleting data : ' + error
          this.dismissibleType = 'danger'
          this.showDismissibleAlert = true
        })
    },
    kioskModeChanged(user) {
      var self = this
      this.boolLoading = true
      var obj = {
        USER_ID: user.USER_ID,
        KIOSK_MODE: user.KIOSK_MODE
      }
      axios.post('/api/UserManagement/ChangeKioskMode', obj)
        .then(response => {
          self.boolLoading = false
        })
        .catch(error => {
          if (error.response.status === 403) { this.$router.push('/login') }

          this.boolLoading = false
          this.errMsg = 'There was an error deleting data : ' + error
          this.dismissibleType = 'danger'
          this.showDismissibleAlert = true
        })
    },
    addUser (p) {
      this.selUserId = -1
      this.toggleModal = true
      this.$refs.addEditUserModal.show()
    },
    openUserDetail (UserID) {
      this.selUserId = UserID
      this.toggleModal = true
      this.$refs.addEditUserModal.show()

      // this.$router.push('/UserManagementDetail/' + UserID)
    },
    confirmEnable (UserID) {
      var self = this

      self.$dialog.confirm('Are you sure you would like to enable user?')
        .then(function () {
          self.enableUser(UserID)
        })
        .catch(function () {

        })
    },
    confirmDisable (UserID) {
      var self = this

      self.$dialog.confirm('Are you sure you would like to disable user?')
        .then(function () {
          self.disableUser(UserID)
        })
        .catch(function () {
          // do nothing
        })
    },
    disableUser (UserID) {
      var self = this
      this.boolLoading = true
      var obj = {
        userId: UserID
      }

      axios.post('/api/UserManagement/Disable', obj)
        .then(response => {
          this.boolLoading = false

          let index = self.users.findIndex(x => x.USER_ID === UserID)
          self.users[index].DISABLED = 1
        })
        .catch(error => {
          if (error.response.status === 403) { this.$router.push('/login') }

          this.boolLoading = false
          this.errMsg = 'There was an error deleting data : ' + error
          this.showDismissibleAlert = true
        })
    },
    enableUser (UserID) {
      var self = this
      this.boolLoading = true
      var obj = {
        userId: UserID
      }

      axios.post('/api/UserManagement/Enable', obj)
        .then(response => {
          this.boolLoading = false

          let index = self.users.findIndex(x => x.USER_ID === UserID)
          self.users[index].DISABLED = 0
        })
        .catch(error => {
          if (error.response.status === 403) {
            self.$router.push('/login')
          }

          var newErrMsg = 'There was an error saving your changes : \n'
          if (error !== undefined && error.response !== undefined && error.response.statusText !== undefined) {
            newErrMsg = newErrMsg + error.response.data
          } else {
            newErrMsg = newErrMsg + error
          }

          alert(newErrMsg)
          self.fetchData()
        })
    },
    IsAdmin: function (UserID) {
      return parseInt(UserID) === 1
    },
    IsDisabled: function (User) {
      return parseInt(User.DISABLED) === 1
    },
    ToggleModal: function () {
      this.$refs.addEditUserModal.hide()
      this.fetchData()
    }
  },
  computed: {
    // whenever question changes, this function will run
    ActiveUsersCount: function () {
      if (this.boolLoading) {
        return null
      } else {
        let list = this.users.filter(user => parseInt(user.DISABLED) === 0)
        return list.length
      }
    },
    CanCreateNewUser: function () {
      if (this.boolLoading) {
        return null
      } else {
        let list = this.users.filter(user => parseInt(user.DISABLED) === 0)
        return list.length < this.maximum_users
      }
    },
    FilteredRecords: function () {
      if (this.boolLoading) {
        return []
      } else {
        if (this.filterShowActiveUsersOnly) {
          return this.users.filter(u => !this.IsDisabled(u))
        } else {
          return this.users
        }
      }
    }
  },
  watch: {
    CanCreateNewUser: {
      immediate: false,
      handler (newVal, oldVal) {
        var self = this
        if (newVal || self.ActiveUsersCount === null) {
          self.dismissibleType = 'danger'
          self.errMsg = ''
          self.showDismissibleAlert = false
        } else {
          self.dismissibleType = 'warning'
          self.errMsg = `We are sorry but you have reached the maximum active user limit. ${self.ActiveUsersCount} active users out of ${self.maximum_users} `
          self.showDismissibleAlert = true
        }
      }
    }
  },
  mounted () {
    // boolLoading must be set to false on data() binding so that mount hooks the change
    this.boolLoading = true
  }
}
</script>

<style>
  .table > tbody > tr > td {
    /*vertical-align: middle;*/
  }

  .table-xtra-condensed > thead > tr > th,
  .table-xtra-condensed > tbody > tr > th,
  .table-xtra-condensed > tfoot > tr > th,
  .table-xtra-condensed > thead > tr > td,
  .table-xtra-condensed > tbody > tr > td,
  .table-xtra-condensed > tfoot > tr > td {
    padding: 2px;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/views/UserManagement.vue